import { Box, Container, Link, ThemeProvider, Typography } from "@mui/material";
import React, { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import AppBaseScreen from "../../components/AppBaseScreen";
import RocketfuelFullLogo from "../../assets/logo/rocketfuel-fulllogo.svg";
import Rocket from "../../assets/logo/rocket.svg";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import AppButton from "../../components/AppButton";
import { useNavigate } from "react-router-dom";
import { gettingStartedTheme } from "../Login/theme";
import { logEvent } from "../../store/api";
import { EVENTS } from "../../utils/events";

export default function GettingStarted() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [active, setActive] = useState(0);
  const handleClick = () => {
    if (active === 2) {
      logEvent({
        current: EVENTS.GETTING_STARTED.title,
        activity: `Navigated to home`,
        meta: {}
      })
      navigate("/accounts");
    } else {

      setActive(active + 1);
      logEvent({
        current: EVENTS.GETTING_STARTED.title,
        activity: `navigated to ${EVENTS.GETTING_STARTED.PAGE} ${active}`,
        meta: {}
      })
    }
  };

  const handleChange = (index) => {

    setActive(index);
    logEvent({
      current: EVENTS.GETTING_STARTED.title,
      activity: `onchange event to ${EVENTS.GETTING_STARTED.PAGE} ${index}`,
      meta: {}
    })
  };
  return (
    <AppBaseScreen isHeader={false}>
      <ThemeProvider theme={gettingStartedTheme}>
        <Container
          maxWidth="xs"
          sx={{
            position: 'relative',
            width: '100%',
            height: '100%',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            background: "transparent",
            paddingLeft: 4,
            paddingRight: 4,
            paddingTop: 5,
            justifyContent: "space-evenly",
          }}
        >
          <Box
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            flexDirection="column"
            marginBottom={2}
          >
            <Typography fontSize={20} fontWeight={700} color="#D4D4D8">
              {t("loginPage.welcome")}
            </Typography>
            <RocketfuelFullLogo />
          </Box>
          <Box>
            <Carousel
              showArrows={false}
              selectedItem={active}
              autoPlay={false}
              showStatus={false}
              onChange={handleChange}
            >
              {[1, 2, 3].map((val) => (
                <Box
                  key={val}
                  display="flex"
                  flexDirection={"column"}
                  justifyContent="space-around"
                  minHeight={'50vh'}
                >
                  <Box
                    display={"flex"}
                    justifyContent={"center"}
                    alignItems={"center"}
                    flexDirection="column"
                  >
                    <Rocket style={{ width: 142 }} />
                  </Box>
                  <Box
                    display={"flex"}
                    flexDirection="column"
                    justifyContent={"center"}
                    marginBottom={2}
                  >
                    <Typography
                      color="#D4D4D8"
                      textAlign={"center"}
                      fontSize={16}
                      textTransform="capitalize"
                      fontWeight={700}
                    >
                      {t(`gettingstartedTitle${val}`)}
                    </Typography>
                    <Typography
                      color="#D4D4D8"
                      textAlign={"center"}
                      fontSize={14}
                      marginBottom={"2vh"}
                      fontWeight={400}
                      data-i18n={`[html]gettingstarted${val}`}
                    >
                      <Trans components={{ a: <Link href="mailto:support@rocketfuel.inc" target="_blank" onClick={() => {
                        logEvent({
                          current: EVENTS.GETTING_STARTED.title,
                          activity: EVENTS.GETTING_STARTED.clickedOnSupport,
                          meta: {
                            data: {
                              source: EVENTS.GETTING_STARTED.title
                            }
                          }
                        })
                      }}/>}}>
                        {t(`gettingstarted${val}`)}
                      </Trans>

                    </Typography>
                  </Box>
                </Box>
              ))}
            </Carousel>
            <AppButton
              title={active === 2 ? t("getStarted") : t("continue")}
              onClick={handleClick}
            />
          </Box>
        </Container>
      </ThemeProvider>
    </AppBaseScreen>
  );
}
